<template>
  <v-data-table
    :items="ingredients"
    :headers="headers"
    :items-per-page="ingredients.length + 1"
    sort-by="ordre"
    hide-default-footer
    hide-default-header
    :mobile-breakpoint="0"
    ref="grid"
    item-key="id"
    dense
  >
    <template v-slot:item.product="{ item }">
      <span :style="{ opacity: item.is_deleted === true ? 0.38 : 1 }">{{
        getName(item)
      }}</span>
    </template>
    <template v-slot:item.quantite="{ item }">
      <span>{{ getConvertedQuantity(item) }}</span>
    </template>
    <template v-slot:item.unite_mesure="{ item }">
      <div style="width: 200px">
        <v-select
          class="no-print"
          label="Unité"
          solo
          flat
          hide-details
          dense
          :value="item.unite_mesure"
          :items="getPossibleUnitSelectionForProduct(item)"
          :disabled="item.is_deleted === true"
          @change="v => convertQuantity(v, item)"
        ></v-select>
        <span v-show="false" class="only-print">
          {{ item.unite_mesure }}
        </span>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { mappers } from "@/mappers";
import round10 from "round10";
export default {
  name: "IngredientViewerGrid",
  props: {
    ingredients: {
      type: Array,
      required: true
    },
    multiple: {
      required: true
    },
    recipeQuantity: {
      required: true
    }
  },
  computed: {
    ...mapGetters([
      "getAllProducts",
      "getOrganisationId",
      "getAllowedUnits",
      "getCustomUnitsValues"
    ])
  },
  data() {
    return {
      headers: [
        { value: "ordre", text: "Ordre" },
        { value: "product", text: "Nom" },
        { value: "quantite", text: "Quantité" },
        { value: "unite_mesure", text: "Unité de mesure" }
      ]
    };
  },
  methods: {
    getPossibleUnitSelectionForProduct(item) {
      if (!mappers.isCustomUnit(item.unite_mesure)) {
        const possibilities = this.$units()
          .from(item.unite_mesure)
          .possibilities();
        return possibilities
          ? possibilities.filter(x => this.getAllowedUnits.includes(x))
          : [item.unite_mesure];
      } else if (mappers.isCustomUnit(item.unite_mesure)) {
        return this.getCustomUnitsValues;
      } else {
        return [];
      }
    },
    convertQuantity(value, item) {
      if (!mappers.isCustomUnit(item.unite_mesure)) {
        item.quantite = this.$units(item.quantite)
          .from(item.unite_mesure)
          .to(value);
        item.unite_mesure = value;
      }
    },
    getConvertedQuantity(item) {
      return round10.round10(
        (item.quantite * (this.multiple * this.recipeQuantity)) /
          this.recipeQuantity,
        -2
      );
    },
    getName(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      if (product !== undefined) {
        return product.nom;
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
